function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

module.exports = function (t) {
  var e = {};

  function n(r) {
    if (e[r]) return e[r].exports;
    var o = e[r] = {
      i: r,
      l: !1,
      exports: {}
    };
    return t[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
  }

  return n.m = t, n.c = e, n.d = function (t, e, r) {
    n.o(t, e) || Object.defineProperty(t, e, {
      enumerable: !0,
      get: r
    });
  }, n.r = function (t) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(t, "__esModule", {
      value: !0
    });
  }, n.t = function (t, e) {
    if (1 & e && (t = n(t)), 8 & e) return t;
    if (4 & e && "object" == _typeof(t) && t && t.__esModule) return t;
    var r = Object.create(null);
    if (n.r(r), Object.defineProperty(r, "default", {
      enumerable: !0,
      value: t
    }), 2 & e && "string" != typeof t) for (var o in t) {
      n.d(r, o, function (e) {
        return t[e];
      }.bind(null, o));
    }
    return r;
  }, n.n = function (t) {
    var e = t && t.__esModule ? function () {
      return t["default"];
    } : function () {
      return t;
    };
    return n.d(e, "a", e), e;
  }, n.o = function (t, e) {
    return Object.prototype.hasOwnProperty.call(t, e);
  }, n.p = "", n(n.s = 0);
}([function (t, e, n) {
  "use strict";

  n.r(e);

  var r = function (t, e, n, r, o, i, s, u) {
    var a,
        c = "function" == typeof t ? t.options : t;
    if (e && (c.render = e, c.staticRenderFns = n, c._compiled = !0), r && (c.functional = !0), i && (c._scopeId = "data-v-" + i), s ? (a = function a(t) {
      (t = t || this.$vnode && this.$vnode.ssrContext || this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) || "undefined" == typeof __VUE_SSR_CONTEXT__ || (t = __VUE_SSR_CONTEXT__), o && o.call(this, t), t && t._registeredComponents && t._registeredComponents.add(s);
    }, c._ssrRegister = a) : o && (a = u ? function () {
      o.call(this, this.$root.$options.shadowRoot);
    } : o), a) if (c.functional) {
      c._injectStyles = a;
      var l = c.render;

      c.render = function (t, e) {
        return a.call(e), l(t, e);
      };
    } else {
      var d = c.beforeCreate;
      c.beforeCreate = d ? [].concat(d, a) : [a];
    }
    return {
      exports: t,
      options: c
    };
  }({
    name: "DoughnutChart",
    props: {
      percent: {
        type: Number,
        "default": 0
      },
      foregroundColor: {
        type: String,
        "default": "#1993ff"
      },
      backgroundColor: {
        type: String,
        "default": "#ecf6ff"
      },
      strokeWidth: {
        type: Number,
        "default": 10
      },
      radius: {
        type: Number,
        "default": 85
      },
      width: {
        type: Number,
        "default": 200
      },
      height: {
        type: Number,
        "default": 200
      },
      visibleValue: {
        type: Boolean,
        "default": !1
      },
      emptyText: {
        type: String,
        "default": ""
      },
      classValue: {
        type: String,
        "default": ""
      }
    },
    data: function data() {
      return {};
    },
    computed: {
      largeArc: function largeArc() {
        return this.percent < 50 ? 0 : 1;
      },
      x: function x() {
        return 100;
      },
      y: function y() {
        return 100 - this.radius;
      },
      endX: function endX() {
        return -Math.sin(this.radians) * this.radius + 100 - 1e-4;
      },
      endY: function endY() {
        return Math.cos(this.radians) * this.radius + 100;
      },
      radians: function radians() {
        return (this.percent / 100 * 360 - 180) * Math.PI / 180;
      },
      z: function z() {
        return 100 === this.percent ? "z" : "";
      },
      dBg: function dBg() {
        return "M ".concat(this.x, " ").concat(this.y, " A ").concat(this.radius, " ").concat(this.radius, " 0 1 1 ").concat(this.x - 1e-4, " ").concat(this.y, " z");
      },
      d: function d() {
        return "M ".concat(this.x, " ").concat(this.y, " A ").concat(this.radius, " ").concat(this.radius, " 0 ").concat(this.largeArc, " 1 ").concat(this.endX, " ").concat(this.endY, " ").concat(this.z);
      },
      valueFromBottom: function valueFromBottom() {
        return this.height / 2 - this.strokeWidth;
      },
      valueFromLeft: function valueFromLeft() {
        return this.width / 2 - this.strokeWidth;
      },
      valueStyle: function valueStyle() {
        return {
          color: this.foregroundColor,
          bottom: "".concat(this.valueFromBottom, "px"),
          left: "".concat(this.valueFromLeft, "px"),
          position: "absolute",
          "font-size": "18px"
        };
      },
      visibleEmptyText: function visibleEmptyText() {
        return ("0" === this.percent || 0 === this.percent) && "" !== this.emptyText;
      }
    }
  }, function () {
    var t = this,
        e = t.$createElement,
        n = t._self._c || e;
    return n("div", {
      staticClass: "doughnut_chart",
      staticStyle: {
        position: "relative"
      }
    }, [n("svg", {
      attrs: {
        width: t.width,
        height: t.height,
        viewBox: "0 0 200 200"
      }
    }, [n("path", {
      attrs: {
        d: t.dBg,
        fill: "transparent",
        stroke: t.backgroundColor,
        "stroke-width": t.strokeWidth
      }
    }), t._v(" "), n("path", {
      attrs: {
        d: t.d,
        fill: "transparent",
        stroke: t.foregroundColor,
        "stroke-width": t.strokeWidth
      }
    })]), t._v(" "), t.visibleValue ? n("div", {
      style: t.valueStyle
    }, [t.visibleEmptyText ? n("span", {
      "class": t.classValue
    }, [t._v(t._s(t.emptyText))]) : n("span", {
      "class": t.classValue
    }, [t._v(t._s(t.percent) + "%")])]) : t._e()]);
  }, [], !1, null, null, null);

  r.options.__file = "DoughnutChart.vue";
  var o = r.exports;
  e["default"] = o;
}]);